import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to fetch resource details
export const fetchResourceDetail = createAsyncThunk(
  "resource/fetchResourceDetail",
  async (resourceId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.recdbase.org/resource/get/${resourceId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Async thunk to fetch paginated data
export const fetchResources = createAsyncThunk(
  "resources/fetchResources",
  async (page, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.recdbase.org/resource/listed?page=${page}`
      );

      console.log(response.data);

      return response.data; // Ensure this matches the API response format
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);




export const fetchSearchDetailsResults = createAsyncThunk(
  "search/fetchSearchResults",
  async ({ searchTerm, selectedFilters, selectedDate, page = 1 }) => {
    const queryParams = new URLSearchParams();
    queryParams.append("query", "search");
    queryParams.append("search", searchTerm);
    queryParams.append("page", page);

    if (selectedFilters.length > 0) {
      queryParams.append("selected", selectedFilters.join(","));
    }

    if (selectedDate) {
      queryParams.append("date", selectedDate); // ✅ Add date filter
    }

    console.log(`Fetching search: ${queryParams.toString()}`);

    const response = await axios.get(
      `https://api.recdbase.org/api/collect?${queryParams}`
    );

    console.log("Search API Response:", response.data);
    return response.data;
  }
);



export const submitResourceForm = createAsyncThunk(
  "resource/submitForm",
  async (formData, { rejectWithValue }) => {
    try {
      const formDataObj = new FormData();

      // Append all form fields
      Object.keys(formData).forEach((key) => {
        if (Array.isArray(formData[key])) {
          formData[key].forEach((item) => formDataObj.append(`${key}[]`, item));
        } else {
          formDataObj.append(key, formData[key]);
        }
      });

      if (formData.uploadedFile) {
        formDataObj.append("uploadedFile", formData.uploadedFile);
      }

      // Get the token from localStorage or sessionStorage
      const token = localStorage.getItem("userToken"); // Or sessionStorage.getItem("token")

      const response = await axios.post("https://api.recdbase.org/resource/create", formDataObj, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Attach token
        },
      });


      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const updateResource = createAsyncThunk(
  "resource/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("userToken"); // Or sessionStorage.getItem("token")

      const response = await axios.put(
        `https://api.recdbase.org/resource/update/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Add token here
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const submitReport = createAsyncThunk(
  "report/submitReport",
  async ({ fullname, email, resource_id, content }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://api.recdbase.org/report/create",
        { fullname, email, resource_id, content }
      );
      alert(response.data.message)

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);



export const fetchProfileView = createAsyncThunk(
  "resource/fetchProfileView",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.recdbase.org/users/getUserArticals/${userId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const fetchRandomResources = createAsyncThunk(
  "resources/fetchRandomResources",
  async (page, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.recdbase.org/resource/resourceRandam?page=${page}`
       
      );

      console.log(response.data);

      return response.data; // Ensure this matches the API response format
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const resourceSlice = createSlice({
  name: "resource",
  initialState: {
    resource: null,
    resources: [],
    randomResources: [],
    resourceProfile: null,
    searchTerm: "",
    selectedDate: "",
    success: false,
    reportSuccess: false,
    summitLoading: false,
    currentPage: 1,
    message: "",
success: false,
loading: false,
updateMessage: "",
    selectedFilters: [],
    totalPages: 1,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSearchTerms: (state, action) => {
      state.searchTerm = action.payload;
    },
    resetState: (state) => {
      state.success = false;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    toggleFilters: (state, action) => {
      const filter = action.payload;
      if (state.selectedFilters.includes(filter)) {
        state.selectedFilters = state.selectedFilters.filter((f) => f !== filter);
      } else {
        state.selectedFilters.push(filter);
      }
    },
   
    clearFilters: (state) => {
      state.selectedFilters = [];
      state.selectedDate = "";
    },
    resetReportState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    clearMessage: (state) => {
      state.message = null; // Reset message to close the popup
    },
  }, // No manual reducers needed for now
  extraReducers: (builder) => {
    builder
      .addCase(fetchResourceDetail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchResourceDetail.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.resource = action.payload;
      })
      .addCase(fetchResourceDetail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

      builder
      .addCase(fetchRandomResources.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRandomResources.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.randomResources = action.payload; // Adjust if API returns data differently
        state.totalPages = action.payload.totalPages || 1; // Adjust based on API response
      })
      .addCase(fetchRandomResources.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Something went wrong!";
      });


      builder
      .addCase(fetchProfileView.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProfileView.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.resourceProfile = action.payload;
      })
      .addCase(fetchProfileView.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

    builder
      .addCase(fetchSearchDetailsResults.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSearchDetailsResults.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Search Data Received:", action.payload); // ✅ Debug log
        state.resources = action.payload; // ✅ Update only `datas`
      })
      .addCase(fetchSearchDetailsResults.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("Search Fetch Error:", action.error.message); // ✅ Debug log
      });

      builder
      .addCase(submitResourceForm.pending, (state) => {
        state.summitLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitResourceForm.fulfilled, (state, action) => {
        state.summitLoading = false;
        state.success = true;
        state.message = action.payload.message
      })
      .addCase(submitResourceForm.rejected, (state, action) => {
        state.summitLoading = false;
        state.success = false;
        state.error = action.payload;
      });
      

      builder
      .addCase(updateResource.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateResource.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updateMessage = action.payload.message
      })
      .addCase(updateResource.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchResources.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchResources.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.resources = action.payload; // Adjust if API returns data differently
        state.totalPages = action.payload.totalPages || 1; // Adjust based on API response
      })
      .addCase(fetchResources.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Something went wrong!";
      });

      builder
      .addCase(submitReport.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitReport.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(submitReport.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { setPage, setSearchTerms, toggleFilters, setMessage, clearMessage, setSelectedDate, clearFilters, resetState,  resetReportState  } = resourceSlice.actions;

export default resourceSlice.reducer;
